import { VueApp } from 'larasnap';
import App from './UploadManager.vue';

export default class extends VueApp {
    static registerAs = 'UploadManager';

    constructor(element) {
        super(element, App);
    }
}
